
async function createResponse(object){

  console.log(object)
const productId = object.id;
const variantPrice = object.price;
// object.grip = object.grip * 1;
const variantTitle = `${object.grip.replace(" ", "")}-${object.width * 100}`;  
  
  
const query = `
           mutation createProductVariant($productId: String!, $variantPrice: String!, $variantTitle: String!, $shopName: String!) {
           createAddProductVariant(addProductVariant: {
                productId: $productId,
                price: $variantPrice,
                variantTitle: $variantTitle,
                shopName: $shopName
          }) {
            success
            errors {
            message
            }
            addProductVariant {
              _all
            }
          }
        }`

  const variables = { "productId": `${productId}`, "variantPrice": `${variantPrice}`, "variantTitle": `${variantTitle}`, 'shopName': 'casablanca' };
     window.api = new Gadget({
    environment: "Development"
  });
   $('#add-to-cart').html('<span class="button__text"><i class="fas fa-cog fa-spin"></i> Se configureaza produsul... </span>').prop('disabled', true);
      
  const response = await api.mutate(query, variables);
  const variantID = response.createAddProductVariant.addProductVariant._all.response;
  const variantExists = response.createAddProductVariant.addProductVariant._all.variantExists;
  
 
    if (response.createAddProductVariant.success) {
      
       $('#add-to-cart').html("<span class='button__text'><i class='fas fa-cog fa-spin'></i> Vă rugăm asteptați... </span>");
      
     let formData = {
         'items': [{
          'id': variantID,
          'quantity': 1,
           "properties" : {
                "Latime": object.width * 100 + "cm",
                "Inaltime": object.height + "cm",
                "Tip": object.grip
          }
          }]
        };
      
      function addToCart() {   
        
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then( response => {
               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true  
                    }));
              setTimeout(function redirect() { window.location.href = '/cart' }, 4000);
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
       
              $('#add-to-cart').prop('disabled', false).prop('onclick',null).off('click').on('click', function(){ window.location.href = '/cart' }).html('<span class="button__text"><i class="fa fa-check"></i> VEZI AICI COȘUL </a></span>')
              
                  };

      
      if (variantExists) { addToCart() } else {setTimeout(addToCart, 17000)};     
  };

}